import React from 'react';

import useCurrentUser from '~/hooks/useCurrentUser';

import AiChatDrawer from './AiChatDrawer';
import AiOpsChatIframeDrawer from './AiOpsChatIframeDrawer';

const AI_OPS_CHAT_IFRAME_ALLOWED_USERS = new Set(
  [
    'luke.wang@luxuryescapes.com',
    'braydn.evans@luxuryescapes.com',
    'william.ritossa@luxuryescapes.com',
    'koren.sela@luxuryescapes.com',
    'lachlan.mellington@luxuryescapes.com',
    'joshua.paling@luxuryescapes.com',
  ].map((email) => email.toLowerCase()),
);

function normalizeEmail(value: string | undefined): string {
  return value?.trim().toLowerCase() || '';
}

function hasAiOpsChatOrigin(): boolean {
  return Boolean(window.configs?.AI_OPS_CHAT_ORIGIN?.trim());
}

export default function AiChatEntry() {
  const { user } = useCurrentUser();
  const userEmail = normalizeEmail(user?.email);

  if (AI_OPS_CHAT_IFRAME_ALLOWED_USERS.has(userEmail) && hasAiOpsChatOrigin()) {
    return <AiOpsChatIframeDrawer />;
  }

  return <AiChatDrawer />;
}
